/**
 * Gets width of text in some element
 * @param fontSize
 * @param value
 * @return number - width of text
 */
export const createOffsetElement = (fontSize: string, value: string): number => {
  const element = document.createElement('div')
  element.innerHTML = value
  element.style.fontSize = fontSize
  element.style.width = 'auto'
  element.style.display = 'inline-block'
  element.style.visibility = 'hidden'
  element.style.position = 'fixed'
  element.style.overflow = 'auto'
  document.body.append(element)
  const width = element.clientWidth
  element.remove()
  return width
}
